/** Indent per level. Enough to read as nesting without pushing a deep row off the rail. */
export const RAIL_INDENT_PX = 12;

/** The left padding a rail row carries at the root, which an indent is added to. */
const RAIL_ROW_PADDING_PX = 12;

/**
 * Left padding for a row nested `depth` levels in.
 *
 * Added to the row's own padding rather than replacing it, so it stays in step with the `px-3` in
 * {@link railRowClass}.
 */
export const railRowIndent = (depth: number) => RAIL_ROW_PADDING_PX + depth * RAIL_INDENT_PX;

/**
 * How one row of a library rail reads, chosen or not.
 *
 * A function shared by the rails rather than a class copied into each: the folders and the tags
 * are two lists of the same kind of thing, sitting in the same column, and a person moving between
 * them should not be able to tell they were built apart. The fill runs past the text on both, which
 * is why the padding belongs to the row and not to what it holds.
 */
export const railRowClass = (active: boolean) =>
  `flex w-full items-center gap-2 rounded-sm px-3 py-2 text-left text-sm transition-colors duration-fast ease-out ${
    active ? 'bg-muted font-medium text-foreground' : 'text-foreground-alt hover:bg-muted'
  }`;
